import { observable } from "mobx";
import { isEmpty } from "../../../utils";
import BaseChannelSettings from "./BaseChannelSettings";

export enum SMSCChannelType {
    SMS = 'sms',
}

export default class SMSCChannelSettings extends BaseChannelSettings {
    @observable sender: string = '';
    @observable contractNumber: number = 0;
    @observable type: SMSCChannelType = SMSCChannelType.SMS;

    constructor(settings?: Partial<SMSCChannelSettings>) {
        super();
        if (settings) this.update(settings);
    }

    get isValid() {
        return !isEmpty(this.accessToken)
            && !isEmpty(this.sender)
            && this.contractNumber > 0;
    }

    update(entity: Partial<SMSCChannelSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    hasChanges(settings: SMSCChannelSettings) {
        return super.hasChanges(settings)
            || this.sender !== settings.sender
            || this.contractNumber !== settings.contractNumber
            || this.type !== settings.type;
    }

    clone() {
        return new SMSCChannelSettings(this);
    }
}